export enum LanguageTag {
  DE_AT = 'de-AT', // German (Austria)
  DE_CH = 'de-CH', // German (Switzerland)
  DE_DE = 'de-DE', // German (Germany)
  ES_ES = 'es-ES', // Spanish (Spain)
  HR_HR = 'hr-HR', // Croatian (Croatia)
  HU_HU = 'hu-HU', // Hungarian (Hungary)
  SK_SK = 'sk-SK', // Slovak (Slovakia)
  SL_SI = 'sl-SI' // Slovenian (Slovenia)
}

const convertCountryToLanguageTag = (countryStr: string): LanguageTag => {
  let languageTag: LanguageTag;

  switch (countryStr) {
    case 'at':
      languageTag = LanguageTag.DE_AT;
      break;
    case 'ch':
      languageTag = LanguageTag.DE_CH;
      break;
    case 'de':
      languageTag = LanguageTag.DE_DE;
      break;
    case 'es':
      languageTag = LanguageTag.ES_ES;
      break;
    case 'hr':
      languageTag = LanguageTag.HR_HR;
      break;
    case 'hu':
      languageTag = LanguageTag.HU_HU;
      break;
    case 'sk':
      languageTag = LanguageTag.SK_SK;
      break;
    case 'si':
      languageTag = LanguageTag.SL_SI;
      break;
    default:
      throw new Error(`Unsupported country: ${countryStr}`);
  }

  return languageTag;
};

export default convertCountryToLanguageTag;
